import { PayrollCycle } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export function getPayrollCycleLabel(
  payrollCycle: PayrollCycle,
  shouldIncludeCycleCount: boolean = true
): string {
  return $enum.visitValue(payrollCycle).with({
    [PayrollCycle.MONTHLY]: () =>
      shouldIncludeCycleCount ? 'Monthly (12 cycles)' : 'monthly',
    [PayrollCycle.SEMI_MONTHLY]: () =>
      shouldIncludeCycleCount ? 'Semi monthly (24 cycles)' : 'semi monthly',
    [PayrollCycle.BIWEEKLY]: () =>
      shouldIncludeCycleCount ? 'Bi weekly (26 cycles)' : 'bi weekly',
    [PayrollCycle.BIWEEKLY_DEDUCTIONS]: () =>
      shouldIncludeCycleCount ? 'Bi weekly* (24 deductions)' : 'bi weekly*',
    [PayrollCycle.WEEKLY]: () =>
      shouldIncludeCycleCount ? 'Weekly (52 cycles)' : 'weekly',
    [PayrollCycle.WEEKLY_DEDUCTIONS]: () =>
      shouldIncludeCycleCount ? 'Weekly* (48 deductions)' : 'weekly*',
  });
}
